<template>
    <jt-form
        :alertType="alert.type"
        :alertShow="alert.show"
        :alertMessage="alert.message"
        v-on:create="create()"
        v-on:closeAlert="closeAlert()"
        v-on:clear="clear()"
        title="Nova duplicata a receber"
    >
        <div class="form-row">
            <div class="col-12 col-md-4">
                <b-form-group
                    label="Documento"
                >
                    <b-form-input
                        type="text"
                        placeholder="Documento"
                        v-model="form.doc"
                        size="sm"
                    />
                    <small v-if="!$v.form.doc.required" >Campo requerido</small>
                    <small v-else-if="!$v.form.doc.numeric" >Campo precisa ser numérico</small>
                    <small v-else-if="!$v.form.doc.minValue" >O valor precisa ser positivo</small>
                </b-form-group>
            </div>
            <div class="col-12 col-md-4">
                <b-form-group
                    label="Nº Parcela"
                >
                    <b-form-input
                        type="text"
                        placeholder="Nº Parcela"
                        v-model="form.parcela"
                        size="sm"
                    />

                    <small v-if="!$v.form.parcela.required" >Campo requerido</small>
                    <small v-else-if="!$v.form.parcela.numeric" >Campo precisa ser numérico</small>
                    <small v-else-if="!$v.form.parcela.minValue" >O valor precisa ser positivo</small>
                </b-form-group>
            </div>
            <div class="col-12 col-md-4">
                <b-form-group
                    label="Nº Série"
                >
                    <b-form-input
                        type="text"
                        placeholder="Nº Série"
                        v-model="form.serie"
                        size="sm"
                    />
                </b-form-group>
            </div>
        </div>

        <div class="form-row">
            <div class="col-12 col-md-3">
                <b-form-group
                    label="Cliente"
                >
                    <v-select 
                        :options="clientes" 
                        v-model="form.cliente"
                        :searchable="true" 
                        textProp="descricao"
                        valueProp="id"
                        labelNotFound="Nenhum valor encontrado."
                    />
                    <small v-if="!$v.form.cliente.required" >Campo requerido</small>
                </b-form-group>
            </div>
            <div class="col-12 col-md-3">
                <b-form-group
                    label="Vendedor"
                >
                    <v-select 
                        :options="funcionarios" 
                        v-model="form.vendedor"
                        :searchable="true" 
                        textProp="descricao"
                        valueProp="id"
                        labelNotFound="Nenhum valor encontrado."
                    />
                    <small v-if="!$v.form.vendedor.required" >Campo requerido</small>
                </b-form-group>
            </div>
            <div class="col-12 col-md-3">
                <b-form-group
                    label="Conta financeira"
                >
                    <v-select 
                        :options="contas" 
                        v-model="form.conta"
                        :searchable="true" 
                        textProp="descricao"
                        valueProp="id"
                        labelNotFound="Nenhum valor encontrado."
                    />
                </b-form-group>
            </div>
            <div class="col-12 col-md-3">
                <b-form-group
                    label="Centro de custo"
                >
                    <v-select 
                        :options="ccustos" 
                        v-model="form.ccusto"
                        :searchable="true" 
                        textProp="descricao"
                        valueProp="id"
                        labelNotFound="Nenhum valor encontrado."
                    />
                </b-form-group>
            </div>
        </div>

        <div class="form-row">
            <div class="col-12 col-md-4">
                <b-form-group
                    label="Emissão"
                >
                    <b-form-datepicker 
                        placeholder="Data de emissão" 
                        size="sm" 
                        v-model="form.emissao" 
                        locale="pt-br"
                    />
                    <small v-if="!$v.form.emissao.required" >Campo requerido</small>
                </b-form-group>
            </div>
            <div class="col-12 col-md-4">
                <b-form-group
                    label="Vencimento"
                >
                    <b-form-datepicker 
                        placeholder="Data de vencimento" 
                        size="sm" 
                        v-model="form.vencimento" 
                        locale="pt-br"
                    />
                    <small v-if="!$v.form.vencimento.required" >Campo requerido</small>
                </b-form-group>
            </div>
            <div class="col-12 col-md-4">
                <b-form-group
                    label="Previsão"
                >
                    <b-form-datepicker 
                        placeholder="Data de previsão" 
                        size="sm" 
                        v-model="form.previsao" 
                        locale="pt-br"
                    />
                    <small v-if="!$v.form.previsao.required" >Campo requerido</small>
                </b-form-group>
            </div>
        </div>

        <div class="form-row">
            <div class="col-12 col-md-4">
                <b-form-group
                    label="Tipo do documento"
                >
                    <v-select 
                        :options="tipodocs" 
                        v-model="form.tipodoc"
                        :searchable="true" 
                        textProp="descricao"
                        valueProp="id"
                        labelNotFound="Nenhum valor encontrado."
                    />
                </b-form-group>
            </div>
            <div class="col-12 col-md-4">
                <input-moeda
                    v-model="form.valor"
                    texto="Valor da conta"
                    titulo="Valor"
                >
                    <small v-if="!$v.form.valor.required" >Campo requerido</small>
                </input-moeda>
            </div>
            <div class="col-12 col-md-4">
                <input-moeda
                    v-model="form.valorpago"
                    texto="Valor pago"
                    titulo="Valor pago"
                >
                </input-moeda>
            </div>
        </div>

        <div class="form-row">
            <div class="col-12 col-md-6">
                <input-moeda
                    v-model="form.juros"
                    texto="Juros"
                    titulo="Juros"
                >
                </input-moeda>
            </div>
            <div class="col-12 col-md-6">
                <input-moeda
                    v-model="form.mora"
                    texto="Mora"
                    titulo="Mora"
                >
                </input-moeda>
            </div>
        </div>
    </jt-form>
</template>
<script>
import { 
    required, 
    numeric, 
    minValue
} from 'vuelidate/lib/validators'

import jtForm from '@/components/form.vue'
import VSelect from '@alfsnd/vue-bootstrap-select'
import inputMoeda from '@/components/inputMoeda.vue'
export default {
    name: 'vwNewReceive',
    components: {
        jtForm,
        VSelect,
        inputMoeda
    },
    data(){
        return {
            form: {
                doc: null,
                parcela: null,
                serie: null,
                cliente: null,
                conta: null,
                ccusto: null,
                emissao: null,
                vencimento: null,
                previsao: null,
                tipodoc: null,
                valor: null,
                mora: null,
                juros: null,
                valorpago: null
            },

            clientes: [],
            funcionarios: [],
            contas: [],
            ccustos: [],

            alert: {
                show: false,
                type: 'warning',
                message: ''
            },

            tipodocs: [
                {id: 1, descricao: "cartão"}
            ],
        }
    },

    validations: {
        form: {
            doc: {
                required,
                numeric,
                minValue: minValue(0)
            },
            parcela: {
                required,
                numeric,
                minValue: minValue(0)
            },

            cliente: {
                required
            },

            vendedor: {
                required
            },

            emissao: {
                required
            },

            vencimento: {
                required
            },

            previsao: {
                required
            },

            valor: {
                required
            }
        }
    },

    mounted(){
        this.buscarClientes()
        this.buscarFuncionarios()
        this.buscarContas()
        this.buscarCCustos()
    },

    computed: {
        getToken(){
            return this.$store.getters.getToken
        }
    },

    methods: {
        buscarCCustos : function(){
            fetch(server + 'crud/duplicatas/centrocusto', {
                method: 'GET',
                headers: new Headers({
                    'token' : this.getToken
                })
            })
                .then(response => {
                    if(response.status == 200){
                        response.json()
                            .then(data => {
                                if(data.data){
                                    this.ccustos = data.response
                                }else{
                                    console.error('Error exception', '=>', data.message)
                                }
                            })
                            .catch(error => {
                                console.error('Error exception', '=>', error.message)
                            })
                    }else{
                        console.error('Error exception', '=>', response.statusText)
                    }
                })
                .catch(error => {
                    console.error('Error exception', '=>', error.message)
                })
        },
        
        buscarContas : function(){
            fetch(server + 'crud/duplicatas/contas/R', {
                method: 'GET',
                headers: new Headers({
                    'token' : this.getToken
                })
            })
                .then(response => {
                    if(response.status == 200){
                        response.json()
                            .then(data => {
                                if(data.data){
                                    this.contas = data.response
                                }else{
                                    console.error('Error exception', '=>', data.message)
                                }
                            })
                            .catch(error => {
                                console.error('Error exception', '=>', error.message)
                            })
                    }else{
                        console.error('Error exception', '=>', response.statusText)
                    }
                })
                .catch(error => {
                    console.error('Error exception', '=>', error.message)
                })
        },

        buscarFuncionarios : function(){
            fetch(server + 'crud/duplicatas/funcionarios', {
                method: 'GET',
                headers: new Headers({
                    'token' : this.getToken
                })
            })
                .then(response => {
                    if(response.status == 200){
                        response.json()
                            .then(data => {
                                if(data.data){
                                    this.funcionarios = data.response
                                }else{
                                    console.error('Error exception', '=>', data.message)
                                }
                            })
                            .catch(error => {
                                console.error('Error exception', '=>', error.message)
                            })
                    }else{
                        console.error('Error exception', '=>', response.statusText)
                    }
                })
                .catch(error => {
                    console.error('Error exception', '=>', error.message)
                })
        },

        buscarClientes: function(){
            fetch(server + 'crud/duplicatas/clientes', {
                method: 'GET',
                headers: new Headers({
                    'token' : this.getToken
                })
            })
                .then(response => {
                    if(response.status == 200){
                        response.json()
                            .then(data => {
                                if(data.data){
                                    this.clientes = data.response
                                }else{
                                    console.error('Error exception', '=>', data.message)
                                }
                            })
                            .catch(error => {
                                console.error('Error exception', '=>', error.message)
                            })
                    }else{
                        console.error('Error exception', '=>', response.statusText)
                    }
                })
                .catch(error => {
                    console.error('Error exception', '=>', error.message)
                })
        },

        create: function(){
            let formErrors  = this.$v.form.$invalid

            if(formErrors === false){
                let formBody = []

                for (let prop in this.form) {
                    if(this.form[prop] !== null){
                        let encodedKey = encodeURIComponent(prop)
                        var encodedValue

                        if([
                            'ccusto',
                            'conta',
                            'agente',
                            'cliente',
                            'vendedor',
                            'tipodoc'
                        ].includes(prop)){
                            encodedValue = encodeURIComponent(this.form[prop].id)
                        }else if([
                            'emissao',
                            'vencimento',
                            'previsao'
                        ].includes(prop)){
                            // let date = this.$moment(prop ,'yyyy-mm-dd')
                            encodedValue = this.$moment(this.form[prop] ,'YYYY-MM-DD').format('DD/MM/YYYY')
                        }else{
                            encodedValue = encodeURIComponent(this.form[prop])
                        }
                        
                        
                        formBody.push(encodedKey + "=" + encodedValue)
                    }
                }

                formBody = formBody.join("&")

                fetch(server + 'crud/duplicatas/nova-dr', {
                    method: 'POST',
                    headers: new Headers({
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'token' : this.getToken
                    }),
                    body: formBody
                })
                    .then(response => {
                        if(response.status == 201){
                            response.json()
                                .then(data => {
                                    if(data.data){
                                        this.alert = {
                                            show: true,
                                            type: 'success',
                                            message: data.message
                                        }
                                    }else{
                                        this.alert = {
                                            show: true,
                                            type: 'warning',
                                            message: data.message
                                        }
                                    }
                                })
                                .catch(error => {
                                        this.alert = {
                                            show: true,
                                            type: 'success',
                                            message: error.message
                                        }
                                })
                        }else{
                            this.alert = {
                                show: true,
                                type: 'success',
                                message: response.statusText
                            }
                        }
                    })
                    .catch(error => {
                        console.error('Error', '=>', error)
                    })
            }else{
                this.alert = {
                    show: true,
                    type: 'warning',
                    message: 'Existem campos inválidos ou sem valor.'
                }
            }
        },

        closeAlert: function(){
            this.alert = {
                type: 'warning',
                message: '',
                show: false
            }
        },

        clear: function(){
            for(let prop in this.form){
                this.form[prop] = null
            }
        }
    }
}
</script>